<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Hubspot" class="d-icon d-icon--hubspot" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="2" width="20" height="20" rx="2" fill="#E77C39"/><path d="M6.6 4a1.6 1.6 0 1 0 .853 2.951l4.79 3.61a3.821 3.821 0 0 0-.843 2.399c0 .993.38 1.895.999 2.576l-1.949 1.949a1.28 1.28 0 1 0 .905.905l2.054-2.054h.001a3.84 3.84 0 0 0 5.67-3.376 3.838 3.838 0 0 0-3.2-3.783v-2.15a1.28 1.28 0 1 0-1.418-2.122 1.28 1.28 0 0 0 .138 2.122v2.15a3.812 3.812 0 0 0-1.376.52L8.172 5.891A1.6 1.6 0 0 0 6.6 4Zm8.64 7.04c1.059 0 1.92.861 1.92 1.92s-.861 1.92-1.92 1.92a1.922 1.922 0 0 1-1.92-1.92c0-1.059.861-1.92 1.92-1.92Z" fill="#fff"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconHubspot',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
